import pino from 'pino';

import { BASE_URL } from './constants';

const sendLogToBackend = async (logs: any) => {
    try {
        await fetch(BASE_URL + '_default/logs/client', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify(logs),
        });
    } catch (e) {
        // silent fail if log backend is down
    }
};

const pinoLogger = pino({
    browser: {
        asObject: true,
        transmit: {
            level: 'info',
            send: function (level: any, logEvent: any) {
                const logs = logEvent.messages.map((msg: any) => ({
                    level: level,
                    message: msg,
                    timestamp: new Date().toISOString(),
                    source: 'umart-admin'
                }));
                sendLogToBackend(logs);
            }
        }
    }
});

export const logger = {
    info: (...args: any[]) => pinoLogger.info({ data: args }),
    error: (...args: any[]) => pinoLogger.error({ data: args }),
    warn: (...args: any[]) => pinoLogger.warn({ data: args }),
    debug: (...args: any[]) => pinoLogger.debug({ data: args }),
};
